import useEffectEvent from './use-effect-event'
import {useEffect} from 'react'

/**
 * Hook to observe the resize of a target element using ResizeObserver
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserver
 *
 * @param {Element} target The target element to observe
 * @param {Function} callback The callback to call when the target element resizes
 */
const useResizeObserver = (target, callback) => {
    const onResize = useEffectEvent(callback)
    useEffect(() => {
        if (!target) return

        const observer = new ResizeObserver(onResize)

        observer.observe(target)

        return () => observer.disconnect()
    }, [target, onResize])
}

export default useResizeObserver
